// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R1o7","controls":"styles_controls__E8EuD","charLimit":"styles_charLimit__2xqeS","input":"styles_input__1XvDW","send":"styles_send__hdQbr"};